import {isDev, TAWK_ID} from 'config';
import {useDesktop} from 'hooks';
import dynamic from 'next/dynamic';
import {FC} from 'react';

const TawkMessengerReact = dynamic(() => import('@tawk.to/tawk-messenger-react'), {ssr: false});
/**
 * TawkMessenger
 * @see - https://github.com/tawk/tawk-messenger-react
 * @returns
 */
export const TawkMessenger: FC = () => {
  const isDesktop = useDesktop();

  if (isDev || !isDesktop) return null;

  return <TawkMessengerReact propertyId={TAWK_ID} widgetId="default" />;
};
